<template>
  <div class="modal">
    <div class="background-overlay"></div>
    <div class="modal-container">
      <div class="modal-close" @click="$emit('close')">
        <CloseIcon />
      </div>
      <div class="modal-content">
        <div class="add-link">
          <div class="title">Quick Create</div>
          <div class="input-fields">
            <label class="default-input">
              <span class="label">Enter ISRC/UPC or Spotify Link</span>
              <input type="text" placeholder="ISRC/UPC or Spotify Link" v-model="source" />
            </label>
            <div class="domain-path">
              <div class="domain">
                <div @click="$refs.select2.click()" class="select">
                  <label>
                    <span class="label">Domain</span>
                  </label>
                  <select ref="select2" v-model="domain" class="standard-select custom-select">
                    <option v-for="(val, i) in custom_domains" :value="val" :key="i">
                      {{ val }}/
                    </option>
                  </select>
                  <ChevronDownIcon class="pointer-events-none" />
                  <span class="focus"></span>
                </div>
              </div>
              <label class="default-input">
                <span class="label">Path</span>
                <input type="text" placeholder="Path (Optional)" v-model="path" />
              </label>
            </div>
            <button
              class="button-default big"
              @click="addLink"
              :disabled="submitting || !source"
            >
              <span v-if="!submitting">Create</span>
              <span v-else>Submitting...</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <SnackBar />
  </div>
</template>
<script>
import CloseIcon from "../../../public/img/icons/close.svg";
import ChevronDownIcon from "../../../public/img/icons/chevron-down.svg";
import { Q_CUSTOM_DOMAINS, Q_QUICK_CREATE_LINK, S_ARTISTS } from "@/graphql";
import SnackBar from "@/components/Custom/SnackBar";

export default {
  name: "quick-create-link",
  components: {
    CloseIcon,
    ChevronDownIcon,
    SnackBar
  },
  data() {
    return {
      source: "",
      domain: "vibe.to",
      path: "",
      artists: [],
      custom_domains: [],
      submitting: false
    };
  },
  apollo: {
    $subscribe: {
      allArtists: {
        query: S_ARTISTS,
        variables() {
          return {
            user_id: this.user.id,
          };
        },
        result({ data }) {
          this.artists = data.artists;
        },
      },
    },
    custom_domains: {
      query: Q_CUSTOM_DOMAINS,
      variables() {
        return {
          user_id: this.user.id,
        };
      },
      result({ data }) {
        this.custom_domains = [
          "vibe.to",
          "listen.to",
          ...data.custom_domains.map((d) => d.domain)
        ];
      },
    },
  },
  methods: {
    async addLink() {
      this.submitting = true;
      try {
        const { data } = await this.$apollo.mutate({
          client: "localClient",
          mutation: Q_QUICK_CREATE_LINK,
          variables: {
            source: this.source,
            domain: this.domain,
            path: this.path,
          },
        });

        const { success, token, artist_id, link_id } = data.quick_create_link;

        if (!success) {
          throw new Error("Something went wrong. Failed to create link");
        }

        if (token) localStorage.setItem("token", token);

        if (artist_id !== this.artist.id) {
          const artist = this.artists.filter(
            (artist) => artist.id === artist_id
          )[0];
          await this.$store.dispatch("setArtist", artist);
        }

        this.$router.push({
          name: "SmartLink",
          params: { id: link_id },
        });

        this.submitting = false;
        this.$emit("close");
      } catch (err) {
        this.submitting = false;
        await this.$store.dispatch("snack", {
          type: "error",
          text: err.message.replace("GraphQL error: ", ""),
        });
      }
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    artist() {
      return this.$store.getters.getArtist;
    }
  },
};
</script>
<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .modal-container {
    padding: 0;
    width: 680px;
    z-index: 98;
    background: linear-gradient(
      241.25deg,
      rgba(41, 39, 85, 0.45) 4.4%,
      rgba(41, 39, 84, 0.85) 61.77%,
      rgba(27, 24, 66, 0.45) 119.94%
    );
    backdrop-filter: blur(23px);
    border-radius: 10px;

    .modal-close {
      cursor: pointer;
      position: absolute;
      top: 18px;
      right: 18px;
      display: flex;
      flex-direction: column;

      &:hover {
        svg {
          path {
            fill: white;
          }
        }

        .close-text {
          color: white;
        }
      }

      svg {
        width: 24px;

        path {
          fill: #8786ab;
        }
      }
    }

    .modal-content {
      display: flex;
      flex-direction: column;

      .add-link {
        padding: 30px;
        display: flex;
        flex-direction: column;

        .title {
          font-weight: 600;
          font-size: 18px;
          color: #ffffff;
        }

        .label {
          font-weight: 700;
          font-size: 14px;
          color: #ffffff;
          text-align: left;
        }

        .input-fields {
          margin-top: 30px;
          display: flex;
          flex-direction: column;

          .default-input {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }

          .domain-path {
            display: flex;
            margin-top: 15px;
            width: 100%;
            gap: 2%;
            .domain {
              width: 49%;
              .select {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                width: 100%;
                .label {
                  display: block;
                }
                select {
                  width: 100%;
                }
              }
            }
            .default-input {
              width: 49%;
            }
          }

          button {
            margin: 30px 0 10px;
          }
        }
      }
    }
  }

  .background-overlay {
    z-index: 97;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: unset;
    /* Purple-dark */
    background: $purple-dark;
    opacity: 0.9;
    backdrop-filter: blur(10px) !important;
  }

  .custom-select{
    border-radius: 5px 0px 0px 5px !important;
    border-right:unset !important;
  }
}
</style>
